import * as UserProfileActions from "./user-profile.actions";
import { createReducer, on } from "@ngrx/store";
import { recursive as mergeRecursive } from "merge";
import { UserProfileState } from "./user-profile.state";

const initialState: UserProfileState = {
    currentUserProfile: null,
};

export const UserProfileReducer = createReducer(
    initialState,
    on(UserProfileActions.ExtendStateAction, (state, { newState }) => ({ ...state, ...newState })),
    on(UserProfileActions.MergeStateAction, (state, { newState }) => mergeRecursive(true, state, newState)),
);
